import {BookingTypeEnum, FlowEnum} from 'presentation/pages/private/booking/constants';
import {FlowTypeEnumWithoutAuth} from './flowType';

export function getBookingTypeByFlowType(flowType: FlowTypeEnumWithoutAuth): BookingTypeEnum {
	const bookingType = {
		[FlowEnum.HEALTH]: BookingTypeEnum.HEALTH,
		[FlowEnum.TELEHEALTH]: BookingTypeEnum.TELEHEALTH,
		[FlowEnum.ODONTO]: BookingTypeEnum.ODONTO,
		[FlowEnum.EXAM]: BookingTypeEnum.EXAM,
	};

	return bookingType[flowType];
}
